import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { authClient } from "../lib/auth/authClient"
import { clearBearerToken } from "../lib/auth/desktopAuth"
import { useUserStore } from "../store"

export const Route = createFileRoute("/logout")({
  component: Logout,
})

function Logout() {
  const navigate = useNavigate()
  const { setUser } = useUserStore((state) => state)

  useEffect(() => {
    async function doLogout() {
      await authClient.signOut()
      clearBearerToken()
      setUser(null)
      navigate({ to: "/login" })
    }
    doLogout()
  }, [])

  return <div>Logging out...</div>
}
